// extracted by mini-css-extract-plugin
export default {"title":"DeliverCard_title__znXpe","value":"DeliverCard_value__qkNaR"};